'use strict';

var BlimpExtListingUtilities = new Class({
	Extends: BlimpExt,
	options: {
		pg_width_by_thumbs: 5,
		data: null
	},

	post_process_build: function post_process_build() {
		this.parent();
		if (!this.first_load) {
			this.set_default_view();
		} else {
			if (this._link.hasClass('gallery_link')) {
				this.status_view = 'pg';
			} else if (this._link.hasClass('floorplan_link')) {
				this.status_view = 'fp';
			} else {
				this.status_view = 'mp';
			}

			if (this.status_view == 'mp') {
				this._monitor = this._element.getElement('.map_container');
				this.initialize_map();
			} else {
				this._monitor = this._element.getElement('.photogallery_container');
				this.create_gallery();
			}

			this.add_links();
		}

		this.first_load = false;
	},

	add_links: function add_links() {
		var _link_container = this._element.getElement('.link_container');

		if (!_link_container || !_link_container.hasClass('_for_listing')) return;

		this._contact_btn = _link_container.getElement('.contact_btn a');

		if (!this._link.getParent('.lst') || !this._link.getParent('.lst').getElement('.map_view') && !this._contact_btn && (this.data.photos.length == 0 || this.data.floorplan.length == 0)) {
			_link_container.dispose();
		} else {
			if (this._link.getParent('.lst').getElement('.map_view')) {
				this._mp_link = new Element('a', {
					'href': '#',
					'text': 'View Map',
					'class': 'map_view raquo ' + (this.status_view == 'mp' ? '_active' : ''),
					'data-rpc': this._link.getParent('.lst').getElement('.map_view').getAttribute('data-rpc-map')
				}).inject(_link_container, 'top');
			}

			if (this._link.getParent('.lst').getElement('.floorplan_link') || this.data.floorplan && this.data.floorplan.length > 0) {
				this._fp_link = new Element('a', {
					'href': '#',
					'text': 'View Floorplan',
					'class': 'floorplan raquo ' + (this.status_view == 'fp' ? '_active' : ''),
					'data-rpc': this._link.getParent('.lst').getElement('.floorplan_link').getAttribute('data-rpc')
				}).inject(_link_container, 'top');
			}

			if (this._link.getParent('.lst').getElement('.gallery_link') || this.data.photos && this.data.photos.length > 0) {
				this._pg_link = new Element('a', {
					'href': '#',
					'text': 'View Photo Gallery',
					'class': 'photogallery raquo ' + (this.status_view == 'pg' ? '_active' : ''),
					'data-rpc': this._link.getParent('.lst').getElement('.gallery_link').getAttribute('data-rpc')
				}).inject(_link_container, 'top');
			}
		}

		// to have some space so the contact btn wont overlapped with the gallery widget if theres no listed by and managed by
		if (this._pg_link && this._fp_link && this._mp_link && _link_container.getElement('.contact_btn') && !this._element.getElement('.listed_by') && !this._element.getElement('.managed_by')) {

			var _header = this._element.getElement('h3');

			if (_header) _header.setStyle('padding-bottom', 30);
		}

		this.add_links_functionality();
	},

	add_links_functionality: function add_links_functionality() {
		var _fp, _pg, _mp;

		if (this._fp_link) {
			this._fp_link.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				if (this.status_view == 'pg') {
					_pg = this._monitor.getElement('.w_photogallery');
				}

				if (_pg) _pg.dispose();

				if (this.status_view == 'mp') {
					_mp = this._monitor.getElement('.map');
				}

				if (_mp) _mp.dispose();

				if (!_fp) {
					var data = null;

					if (this.data.floorplan) {
						data = {
							photos: this.data.floorplan,
							content: this.data.content
						};
					}

					this.initialize_gallery(this._monitor, data);
					_fp = this._monitor.getElement('.w_photogallery');
				} else {
					this._monitor.adopt(_fp);
				}

				if (this._pg_link) this._pg_link.removeClass('_active');

				if (this._mp_link) this._mp_link.removeClass('_active');

				this._fp_link.addClass('_active');
				this.status_view = 'fp';
			}.bind(this));
		}

		if (this._pg_link) {
			this._pg_link.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				if (this.status_view == 'fp') {
					_fp = this._monitor.getElement('.w_photogallery');
				}

				if (_fp) _fp.dispose();

				if (this.status_view == 'mp') {
					_mp = this._monitor.getElement('.map');
				}

				if (_mp) _mp.dispose();

				if (!_pg) {
					var data = this.data.photos ? this.data : null;

					this.initialize_gallery(this._monitor, data);
					_pg = this._monitor.getElement('.w_photogallery');
				} else {
					this._monitor.adopt(_pg);
				}

				if (this._fp_link) this._fp_link.removeClass('_active');

				if (this._mp_link) this._mp_link.removeClass('_active');

				this._pg_link.addClass('_active');
				this.status_view = 'pg';
			}.bind(this));
		}

		if (this._mp_link) {
			this._mp_link.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				if (this.status_view == 'pg') {
					_pg = this._monitor.getElement('.w_photogallery');
				}

				if (_pg) _pg.dispose();

				if (this.status_view == 'fp') {
					_fp = this._monitor.getElement('.w_photogallery');
				}

				if (_fp) _fp.dispose();

				if (!_mp) {
					this.initialize_map();
					_mp = this._monitor.getElement('.map');
				} else {
					this._monitor.adopt(_mp);
				}

				if (this._pg_link) this._pg_link.removeClass('_active');

				if (this._fp_link) this._fp_link.removeClass('_active');

				this._mp_link.addClass('_active');
				this.status_view = 'mp';
			}.bind(this));
		}

		if (this._contact_btn && this._link.getParent('.ava_apts')) {
			new Blimp.Form(this._contact_btn, { draggable: true, allow_others: true });
		}
	},

	set_default_view: function set_default_view() {
		if (this._element.getElement('.w_popup').hasClass('floorplan') && this.status_view != 'fp') {
			if (this._fp_link) this._fp_link.fireEvent('click');
		} else if (this._element.getElement('.w_popup').hasClass('photogallery') && this.status_view != 'pg') {
			if (this._pg_link) this._pg_link.fireEvent('click');
		} else if (this.status_view != 'mp') {
			if (this._mp_link) this._mp_link.fireEvent('click');
		}
	},

	create_gallery: function create_gallery() {
		if (!this.photogallery) {
			var fp_data;
			this.data = this.data || this.options.data;

			if (this._element.getElement('.w_popup').hasClass('floorplan') && this.data.floorplan) {
				fp_data = {
					photos: this.data.floorplan && this.data.floorplan.length > 0 ? this.data.floorplan : this.data.photos,
					content: this.data.content
				};
			}

			var _phg = this._element.getElement('.w_photogallery');

			var data = fp_data || this.data;

			this.initialize_gallery(_phg, data);

			//this.photogallery.popup = this;
		}
	},

	initialize_gallery: function initialize_gallery(_element, data) {
		var self = this;

		if (data) {
			new PagePhotogallery(_element, {
				data: data,
				thumbs_amount: this.options.width_by_thumbs,
				no_fullscreen_opt: true
			});
		} else {
			var rpc;

			if (this.status_view == 'fp') {
				rpc = this._fp_link.getAttribute('data-rpc');
			} else {
				rpc = this._pg_link.getAttribute('data-rpc');
			}

			self.remote = new Remote({
				rpc: rpc,
				method: 'get',
				onSuccess: function onSuccess() {
					var data = this.get_data();

					self.data.content = data.content;
					self.data.photos = data.photos;
					self.data.floorplan = data.floorplan;

					if (self.status_view == 'fp') {
						data = {
							photos: data.floorplan,
							content: data.content
						};
					}

					new PagePhotogallery(_element, {
						data: data,
						thumbs_amount: self.options.width_by_thumbs,
						no_fullscreen_opt: true
					});
				}
			});
		}
	},

	initialize_map: function initialize_map() {
		var self = this;
		var rpc = this._mp_link ? this._mp_link.getAttribute('data-rpc') : this._link.getAttribute('data-rpc-map');
		var _map = new Element('div', {
			'class': 'map'
		}).inject(this._monitor);

		self.remote = new Remote({
			rpc: rpc,
			method: 'get',
			onSuccess: function onSuccess() {
				var data = this.get_data();

				self.map = new SimpleMap(_map, {
					zoom: data.ini.zoom,
					max_zoom: 17,
					min_zoom: 10,
					lat: data.ini.lat,
					lng: data.ini.lng,
					street_view_control: true,
					onMapReady: function onMapReady() {
						this.add_marker({
							lat: data.ini.lat,
							lng: data.ini.lng,
							icon: data.ini.markers_path + 'base.png',
							bubble_content: data.base_location.name
						});
					}
				});
			}
		});
	}
});
'use strict';

/*
---
author:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.4.5: '*'
...
*/

var FormSupport = new Class({
	Implements: [Events, Options],

	options: {
		validation: true,
		native_submit: true
	},

	initialize: function initialize(form, options) {
		if (!form || form.supported) return;

		this.setOptions(options);
		this._form = form;
		this._form.supported = true;

		this.build();
	},

	build: function build() {
		this._form.addEvents({
			submit: function (e) {
				if (!this.options.native_submit && e && e.stop) {
					e.stop();
				}

				// var category = this.options.category || window.pageType;
				// if (category && this.options.action) {
				// 	// console.log('FormSupport', category, this.options.action, this.options.label);
				// 	_gaq.push(['_trackEvent', category, this.options.action, this.options.label]);
				// }

				this.fireEvent('submit', [this._form.is_valid]);
			}.bind(this)
		});

		this._form.getElements('.errorMessage').each(function (_el) {
			var _parent = _el.getParent('li');

			if (_parent) {
				_parent.addClass('_failed');
			}
		});

		this.style_fields();
		this.style_checkboxes();
		this.style_radios();

		if (this.options.validation) {
			this.add_validator();
		} else {
			this._form.is_valid = true;
		}
	},

	style_fields: function style_fields() {
		var _fields = this._form.getElements('[type="text"], [type="password"], textarea');

		_fields.each(function (_el) {
			if (_el.getAttribute('self-overtext') != 'true') {
				if (_el.getAttribute('get-title')) {
					var _label = _el.getPrevious('label') || _el.getNext('label');

					if (_label) {
						var _span = _label.getElement('span.asterisk');

						if (_span) {
							_span.dispose();
						}

						var title = _label.get('text');
						_el.setAttribute('title', title);

						_label.dispose();
					}
				}

				if (!_el.getProperty('placeholder')) {
					new TextOver(_el);
				}
			}

			if (_el.getProperty('disabled')) {
				_el.getParent().addClass('_disabled');
			}

			_el.addEvents({
				'focus': function focus(e) {
					_el.getParent().addClass('_focused');
				},

				'blur': function blur() {
					_el.getParent().removeClass('_focused');
				}
			});
		});
	},

	style_checkboxes: function style_checkboxes() {
		var _checkboxes = this._form.getElements('.w_styled_checkbox');

		if (_checkboxes && _checkboxes.length > 0) {
			_checkboxes.each(function (_el) {
				new StyledCheckbox(_el);
			});
		}
	},

	style_radios: function style_radios() {
		this._form.getElements('.w_styled_radio').each(function (_el) {
			var checked = false;
			var _lis = _el.getElements('li');

			_lis.each(function (_e) {
				var _radio = _e.getElement('input[type="radio"]');

				if (_radio && _radio.checked) {
					_e.addClass('_selected');
					checked = true;
				}

				_e.addEvent('click', function () {
					if (_e.hasClass('_selected')) return;

					var _selected = _el.getElement('._selected');

					if (_selected) {
						_selected.removeClass('_selected');
					}

					_e.addClass('_selected');

					if (_radio) {
						_radio.checked = true;
					}
				});
			});

			if (!checked && _lis.length > 0) {
				var _radio = _lis[0].getElement('input[type="radio"]');

				if (_radio) {
					_lis[0].fireEvent('click');
				}
			}
		});
	},

	add_validator: function add_validator() {
		new Form.Validator.Inline(this._form, {
			errorPrefix: '',
			evaluateFieldsOnBlur: false,
			evaluateFieldsOnChange: false,
			scrollToErrorsOnSubmit: false,

			onFormValidate: function onFormValidate(passed, _form, e) {
				_form.is_valid = passed;

				_form.getElements('li').each(function (_el) {
					if (!_el.getElement('.errorMessage')) {
						if (!_el.getAttribute('data-failed')) {
							_el.removeClass('_failed');
						}
					}

					var _label = _el.getElement('label');
					if (_label) _label.removeClass('failed');
				});

				if (!passed || _form.getElement('._failed')) {
					_form.addClass('has_errors');

					_form.getElements('.validation-failed').each(function (_el) {
						var _li = _el.getParent('li');

						if (!_li) return;

						var _error = _li.getElement('.errorMessage');
						if (_error) _error.dispose();

						_li.addClass('_failed');

						if (_li.getElement('label')) {
							_li.getElement('label').addClass('failed');
						}
					});

					var _lis = _form.getElements('li');

					_lis.each(function (_li) {
						var _advices = _li.getElements('.validation-advice');

						if (_advices.length > 1) {
							(function () {
								if (_li.getElement('input').get('id') == 'FormResetPasswordChange_password' && _li.getElement('input').get('value') == '') {
									_advices[0].dispose();
								} else {
									_advices[1].dispose();
								}
							}).delay(100);
						}
					});
				} else {
					_form.removeClass('has_errors');
					_form.fireEvent('validationPassed', [e]);
				}
			}
		});

		if (!Locale_is_defined) {
			Locale.define('en-US', 'FormValidator', {
				email: 'Please enter a valid email address.',
				minLength: 'Please enter at least {minLength} characters',
				digits: 'Please use numbers and punctuation only'
			});

			Locale_is_defined = true;
		}
	}
});
'use strict';

var ImgLazyLoad = new Class({
	Implements: [Options, Events],

	options: {
		range: 200,
		empty_image: Res_i + '/l/dummy.png',
		elements: 'img._lazy',
		container: document.body
	},

	initialize: function initialize(options) {
		var self = this;

		this.setOptions(options);
		this._container = $(this.options.container);

		if (!this._container) return;

		this.container_height = this._container.getSize().y;

		this._elements = this._container.getElements(this.options.elements);

		this._elements.each(function (_el) {
			if (_el.get('tag') != 'img') return;

			_el._cont = new Element('span', {
				'class': 'w_imglazyload'
			});

			_el._cont.inject(_el, 'before');

			_el._cont.adopt(_el);
		});

		this.initial_filtering();

		window.addEvents({
			'scroll': function scroll() {
				self.check_position();
			}
		});
	},

	initial_filtering: function initial_filtering() {
		var self = this;

		this._elements = this._elements.filter(function (_el) {
			if (document.body.getScroll().y + window.getSize().y + self.options.range >= _el.getPosition().y) {
				if (_el.get('tag') == 'img') {
					self.display_image(_el);
				} else {
					_el.getElements('img').each(function (_e) {
						self.display_image(_e);
					});
				}
			} else {
				if (_el.get('tag') == 'img') {
					self.hold_image(_el);
				} else {
					_el.getElements('img').each(function (_e) {
						self.hold_image(_e);
					});
				}

				return true;
			}
		}, this);
	},

	hold_image: function hold_image(_el) {
		var src = _el.get('src') || _el.getAttribute('data-src');

		if (src && src != '') {
			_el.setAttribute('data-src', src);
		}

		_el.set('src', this.options.empty_image);
	},

	display_image: function display_image(_el) {
		if (_el.get('tag') == 'img') {
			this.set_image(_el);
		} else {
			_el.getElements('img').each(function (_e) {
				this.set_image(_e);
			}.bind(this));
		}
	},

	set_image: function set_image(_el) {
		var src = _el.getAttribute('data-src');

		new Asset.image(src, {
			onLoad: function onLoad() {
				_el.set('src', src);

				if (_el._cont) {
					_el.inject(_el._cont, 'after');
					_el._cont.dispose();
				}
			}
		});
	},

	check_position: function check_position() {
		var self = this;

		this._elements = this._elements.filter(function (_el, i) {
			if (document.body.getScroll().y + window.getSize().y + self.options.range >= _el.getPosition().y) {
				if (_el.get('tag') == 'img') {
					self.display_image(_el);
				} else {
					_el.getElements('img').each(function (_e) {
						self.display_image(_e);
					});
				}

				return false;
			}

			return true;
		});

		if (this._elements.length == 0) {
			this._container.removeEvent('scroll', this.check_position.bind(this));
		}
	}
});
'use strict';

var PageVeil = new Class({
	Implements: [Events, Options],

	options: {
		cls: 'w_pageveil',
		rpc: null,
		center_content: false
	},

	initialize: function initialize(options) {
		this.setOptions(options);
		this._element = new Element('.' + this.options.cls, {
			html: '<div class="' + this.options.cls + '_content"></div>' + '<div class="close">&nbsp;</div>'
		});

		this.build();
	},

	build: function build() {
		var self = this;

		this._element.set('tween', {
			duration: 300,
			unit: '%',
			transition: Fx.Transitions.linear,
			onComplete: function onComplete() {
				if (!self.active) {
					self._element.dispose();
				}
			}
		});

		this._element.setStyle('height', window.getSize().y);

		window.addEvents({
			'resize': function resize() {
				self._element.setStyle('height', window.getSize().y);
				self.center_content();
			}
		});

		this._close = this._element.getElement('.close');

		this._close.addEvent('click', function () {
			self.close();
		});

		this.make_rpc_call();
	},

	open: function open() {
		this._element.inject($(document.body));
		this._element.tween('bottom', 0);

		this.active = true;
		this.center_content();
	},

	close: function close() {
		this._element.tween('bottom', 100);
		this.active = false;
	},

	make_rpc_call: function make_rpc_call() {
		if (!this.options.rpc) {
			console.warn('No rpc url provided for page veil content');
			return;
		}

		if (this._content) {
			this.set_content();
			return;
		}

		var self = this;
		this._element.addClass('_loading');

		this.request = new Request.JSON({
			url: this.options.rpc,
			onSuccess: function onSuccess(data) {
				self.set_content(data.content);
			}
		}).send();
	},

	set_content: function set_content(content) {
		if (!content) return;

		var self = this;

		this._content = content;
		this._element.getElement('.' + this.options.cls + '_content').set('html', content);

		this.fireEvent('contentInjection', [this._element]);

		var _img = this._element.getElement('img');

		if (_img) {
			Asset.image(_img.get('src'), {
				onLoad: function onLoad() {
					self.post_set_content();
				}
			});
		} else {
			this.post_set_content();
		}
	},

	post_set_content: function post_set_content() {
		this._element.removeClass('_loading');

		if (this.options.center_content) {
			this.center_content();
		}
	},

	center_content: function center_content() {
		var window_height = this._element.getSize().y;
		var _content = this._element.getElement('.' + this.options.cls + '_content');
		var content_height = _content.getSize().y;
		var mt = (window_height - content_height) / 2;

		mt = mt < 0 ? 0 : mt;

		_content.setStyle('margin-top', mt);
	}
});
'use strict';

var SideTabs = new Class({
	Implements: [Events, Options],

	options: {
		cls: 'w_sidetabs'
	},

	initialize: function initialize(element, options) {
		if (!element) return;

		this._element = element;
		this.setOptions(options);
		this.build();
	},

	build: function build() {
		this._tabs = this._element.getChildren();

		this.create_toggles();
	},

	create_toggles: function create_toggles() {
		var self = this;

		this._tabs.each(function (_el, i) {
			var _toggle = _el._toggle = new Element('.tab_toggle');

			_toggle.inject(_el, 'top');
			_toggle._tab = _el;

			_el.set('tween', {
				duration: 300,
				unit: '%',
				transition: Fx.Transitions.linear,
				onComplete: function onComplete() {}
			});

			(function () {
				_toggle.addEvents({
					'click': function click() {
						_el.toggleClass('_active');

						if (_el.hasClass('_active')) {
							_el.tween('left', [0, -100]);
							self.fireEvent('open');
						} else {
							_el.tween('left', [-100, 0]);
							self.fireEvent('close');
						}
					}
				});

				if (!_el.get('autoopen') && _el.get('autoopen') != '') {
					_toggle.fireEvent('click');
				}
			}).delay(1500);
		});
	}
});
'use strict';

/*
---
description: Lazy widget for save delete listing toggler
authors:
- David Chan CK
license:
- MIT-style license
requires:
- core/1.4.0: '*'
- more/1.4.0.1: [Utilities.Assets]
provides: [SaveDelete]
...
*/

var SaveDelete = new Class({
	Implements: [Options, Events],
	options: {
		cls: 'link-icon',
		url_save: '',
		url_delete: '',
		url_signin: '',
		relayed_data: null, // delegated selector
		create_button: true
	},

	initialize: function initialize(_scope, options) {
		if (!_scope) return;

		this._scope = _scope;
		this.setOptions(options);
		this.build();
	},

	build: function build() {
		var self = this;
		var opts = this.options;

		this.active_id = null;
		this.request_object = null;

		this._scope.getElements(opts.relayed_data).each(function (_el) {
			if (_el.getElement('.w_savedelete') && opts.create_button) return;

			var _btn = self.create_button_for_row(_el);

			if (!_btn) return;

			var url = self.clean_url(opts.url_signin);

			if (url && url != '') {
				_btn.set({
					'class': 'w_savedelete reg_blimp _save_listing',
					'data-listing-token': _el.getAttribute('data-id')
				});

				Core.add_signup_link(_btn);
			} else {
				_btn.addEvent('click', function (e) {
					self.handle_mouseclick(e, _btn);
				});
			}
		});
	},

	clean_url: function clean_url(dirty) {
		if (!dirty) return;

		var first_char = dirty.substr(0, 1);
		var last_char = dirty.substr(dirty.length - 1, 1);
		var clean = dirty;

		if (first_char == '#') {
			clean = clean.substr(1, clean.length - 1);
		}

		if (last_char == '?') {
			clean = clean.substr(0, clean.length - 1);
		}

		return clean;
	},

	create_data_object: function create_data_object(source) {
		var opts = this.options;
		var status;
		var id;

		switch (typeOf(source)) {
			case 'element':
				status = source.getAttribute('data-savedelete-status') || "-1";
				id = source.getAttribute('data-id') || "0";
				break;
			case 'object':
			default:
				status = source.status;
				id = source.id;
				break;
		}

		if (status == '-1') return;

		var cls = null,
		    rpc = '',
		    data_cls = null;

		switch (status) {
			case "0":
				// deleted
				cls = '_save';
				rpc = this.clean_url(opts.url_save);
				break;
			case "1":
				// saved
				cls = '_delete';
				rpc = this.clean_url(opts.url_delete);
				break;
			case "2":
				// not logged in
				cls = '';
				data_cls = 'w_blimp_signin';
				rpc = this.clean_url(opts.url_signin);
				break;
			case "-1":
			default:
				// not applicable
				break;
		}

		return {
			status: status,
			id: id,
			rpc: rpc,
			cls: cls,
			data_cls: data_cls
		};
	},

	handle_mouseclick: function handle_mouseclick(e, _el) {
		e.stop();
		var data = _el.data;

		new Request.JSON({
			url: data.rpc,
			data: Object.toQueryString({
				t: data.id
			}),
			onComplete: function (response_object) {
				this.fireEvent('change', [response_object, _el]);
				_el.dispose();
			}.bind(this)
		}).get();
	},

	create_button_for_row: function create_button_for_row(_row) {
		var opts = this.options;
		var data = this.create_data_object(_row);

		if (!data) return;

		var _btn;

		if (opts.create_button) {
			var _parent = _row.getElement('.links-icons') || _row;

			_btn = new Element('span.' + opts.cls, {
				'html': '<i class="fa fa-heart-o" aria-hidden="true"></i><span class="link-label">Save</span>'
			}).inject(_parent);
		} else {
			_btn = _row.getElement('.w_savedelete');
		}

		_btn.data = data;

		if (data.cls) {
			_btn.addClass(data.cls);
		}

		if (data.data_cls) {
			_btn.setAttribute('data-class', data.data_cls);
		}

		_btn.store('position', _btn.getPosition());

		return _btn;
	}
});
'use strict';

var ScrollToElement = new Class({
	Implements: [Events, Options],

	options: {
		cls: 'scroll_to',
		offset_y: 0
	},

	initialize: function initialize(_elements, options) {
		this.setOptions(options);
		this._elements = _elements || document.getElements('.' + this.options.cls);

		if (this._elements) {
			this.build();
		}
	},

	build: function build() {
		this.setScrollTo();
	},

	setScrollTo: function setScrollTo() {
		var self = this;

		var myFx = new Fx.Scroll(window, {
			offset: {
				x: 0,
				y: self.options.offset_y,
				duration: 1000
			},
			onStart: function onStart() {
				$(window).fireEvent('jumpStart');
			},
			onComplete: function onComplete() {
				$(window).fireEvent('jumpStop');
			}

		});

		this._elements.each(function (link) {
			link.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				if (this.hasClass('_top')) {
					myFx.toTop();
					return;
				}

				var name = (this.get('data-href') || this.get('href') || this.href).split('#')[1];
				var elem = $$('a[name=' + name + ']');
				myFx.toElement(elem[0], 'y');
			});
		});
	}
});
'use strict';

var MultiselectHom = new Class({
	Implements: [Events, Options],

	options: {
		cls: 'w_multiselect_hom',
		max_queen: 12,
		map_options: {
			zoom: 11,
			min_zoom: 11,
			max_zoom: 14,
			lng: -73.99,
			zoom_control: true,
			restrict: {
				ne: {
					lat: 40.88
				}
			},
			style: 'light'

		}
	},

	initialize: function initialize(element, options) {
		this.setOptions(options);
		this._element = element;
		if (this._element) {
			this.build();
		}
	},

	build: function build() {
		this._list = this._element.getElement('ul');
		var _children = this._children = this._list.getChildren();

		/**
  VERY IMPORTANT!!!
  1 - add relationship slave/master
  2 - add click event on every el
  3 - group them.
  **/
		this.add_relationship();

		this.add_click(_children);

		this.group_elements();
	},

	add_click: function add_click(_children) {
		var self = this;

		_children.each(function (_el, i) {
			if (_el.hasClass('ace')) {
				return;
			}

			_el.addEvents({
				'click': function click(e) {
					if (e && e.stop) {
						e.stop();
					}

					self.toggle_element(_el);
					self.fireEvent('click'); //to send request in homesearch class
				}
			});

			_el._check = _el.getElement('input[type="checkbox"]');

			if (_el._check) {
				if (_el._check.checked || _el._check.getAttribute('checked')) {
					self.toggle_element(_el);
				}
			}
		});
	},

	group_elements: function group_elements() {
		var self = this;
		var _group_king;
		var _group_queen;
		var _group_queen_bk;
		var _group_queen_fl;
		var count;
		this._element.getElements('li').each(function (_el) {
			if (_el.hasClass('ace')) {
				count = 0;
				_group_king = new Element('ul', { 'class': 'group_king clearfix' }).inject(_el);
			}

			if (_el.hasClass('king')) {
				count = 0;
				_group_queen = new Element('ul', { 'class': 'group_queen' }).inject(_el);
				_group_queen_fl = new Element('ul', { 'class': 'group_queen_fl' }).inject(_el);
				_el.inject(_group_king);
			}

			if (_el.hasClass('queen')) {
				if (count < self.options.max_queen) {
					_el.inject(_group_queen);
					count++;
				} else {
					_el.inject(_group_queen_fl);
				}
			}
		});
	},
	set_nh_coordinates: function set_nh_coordinates() {
		this._children.each(function (_el, i) {
			var _coords = _el.getElement('.hoods_coordinates');

			if (_coords) {
				_el.region_coords = JSONMOO.decode(_coords.get('html'));
			} else {
				var _checkbox = _el.getElement('input[type="checkbox"]');
				var id = _checkbox ? _checkbox.get('value') : null;

				if (id && _el._master.region_coords) {
					_el.coords = _el._master.region_coords[id];
				}
			}
		});
	},

	select_slaves_regions: function select_slaves_regions(_el) {
		var self = this;
		var _slaves = _el._slaves;

		if (!_slaves || _slaves.length == 0) return;

		_slaves.each(function (_e) {
			if (_e._slaves) {
				self.select_slaves_regions(_e);
			}

			if (_e.map_region) {
				(function () {
					if (_el.hasClass('_selected')) {
						self.regions_map.select_region(_e.map_region);
					} else {
						self.regions_map.deselect_region(_e.map_region);
					}
				}).delay(50);
			}
		});
	},

	add_relationship: function add_relationship() {
		var _aces = this._list.getElements('.ace');

		if (!_aces || _aces.length == 0) {
			return;
		}

		_aces.each(function (_el) {
			_el._slaves = [];
		});

		var _kings = this._list.getElements('.king');
		var _queens = this._list.getElements('.queen');

		if (_kings && _kings.length > 0) {
			this.find_slaves(_aces, 'ace', 'king');

			if (_queens && _queens.length > 0) {
				this.find_slaves(_kings, 'king', 'queen');
			}
		}
	},

	find_slaves: function find_slaves(array, master_class, slave_class) {
		var self = this;

		if (array.length == 0) return;

		array.each(function (_master) {
			var add_child = false;

			self._children.each(function (_el) {
				if (add_child) {
					if (_el.hasClass(slave_class)) {
						_master._slaves.push(_el);
						_el._master = _master;
						_el._slaves = [];
					} else if (_el.hasClass(master_class)) {
						add_child = false;
						return;
					}
				}

				if (_el == _master) {
					add_child = true;
				}
			});
		});
	},

	toggle_element: function toggle_element(_el) {
		var self = this;

		if (_el.hasClass('_active') || _el.hasClass('_semiactive')) {
			this.deselect_element(_el);
			this.deselect_master(_el);
		} else {
			this.select_element(_el);
			this.select_master(_el);
		}
	},

	select_element: function select_element(_el) {
		_el.addClass('_selected');
		_el.removeClass('_semiactive').addClass('_active');

		if (_el._check && !_el._check.checked) {
			_el._check.checked = true;
		}

		this.select_slaves(_el);
	},

	select_slaves: function select_slaves(_el) {
		var _slaves = _el._slaves;

		if (!_slaves || _slaves.length == 0) return;

		_slaves.each(function (_e) {
			this.select_element(_e);
		}.bind(this));
	},

	select_master: function select_master(_el) {
		var _master = _el._master;

		while (_master) {
			if (this.allSelected(_master)) {
				_master.removeClass('_semiactive').addClass('_active');
			} else {
				_master.removeClass('_active').addClass('_semiactive');
			}
			_master = _master._master;
		}
	},

	allSelected: function allSelected(_el) {
		var _siblings = _el._slaves;
		var allSelected = true;

		if (_siblings && _siblings.length > 0) {
			_siblings.each(function (_e) {
				if (!_e.hasClass('_active')) {
					allSelected = false;
					return;
				}
			});
		}

		return allSelected;
	},

	deselect_element: function deselect_element(_el) {
		_el.removeClass('_selected');
		_el.removeClass('_active').removeClass('_semiactive');

		if (_el._check) {
			_el._check.checked = false;
		}

		this.deselect_slaves(_el);
	},

	deselect_slaves: function deselect_slaves(_el) {
		var _slaves = _el._slaves;

		if (!_slaves || _slaves.length == 0) return;

		_slaves.each(function (_e) {
			this.deselect_element(_e);
		}.bind(this));
	},

	deselect_master: function deselect_master(_el) {
		var _master = _el._master;

		while (_master) {
			if (this.hasSelected(_master)) {
				_master.removeClass('_active').addClass('_semiactive');
			} else {
				_master.removeClass('_active').removeClass('_semiactive');
			}

			_master = _master._master;
		}
	},

	hasSelected: function hasSelected(_el) {
		var _siblings = _el._slaves;
		var hasSelected = false;
		if (_siblings && _siblings.length > 0) {
			_siblings.each(function (_e) {
				if (_e.hasClass('_active') || _e.hasClass('_semiactive')) {
					hasSelected = true;
					return;
				}
			});
		}
		return hasSelected;
	}
});
'use strict';

var BlimpExtSignOut = new Class({
	Extends: BlimpExt,

	post_process_build: function post_process_build() {
		var _email_us = this._element.getElement('.w_blimp_contact_us_sign_out');

		if (_email_us) {
			if (!this.email_us) this.email_us = new Blimp.Form(_email_us, {
				draggable: true,
				scrollable: false,
				'onShow': function onShow() {
					Core.stop_window_scroll();
				},
				'onHide': function onHide() {
					Core.resume_window_scroll();
				}
			});
		}
		this.fireEvent('beforeShow');
		this.show();
	}
});
'use strict';

var Streetview = new Class({
	Implements: [Options, Events],

	options: {
		cls: "w_streetview",
		container: null,
		zoomControl: true
	},

	initialize: function initialize(element, options) {
		this.setOptions(options);
		this._element = element;

		if (this._element) {
			Core.load_google_api(this.build.bind(this));
		}
	},

	build: function build() {
		var _self = this._element,
		    opts = this.options,
		    cls = opts.cls;

		this.mode = 'webgl';
		this.check_webgl();

		var _config = _self.getElement('.' + cls + '_config');
		var _pano = this._pano = _self.getElement('.' + cls + '_pano');

		if (_pano && _config) {
			var config = this.config = JSONMOO.decode(_config.get('text').toString().trim(), false);
			config.mode = this.mode;

			if (!config.position && config.lat && config.lng) {
				config.position = new google.maps.LatLng(config.lat, config.lng);
			}

			var default_config = {
				position: new google.maps.LatLng(40.7642676, -73.9741554),
				addressControl: false,
				scrollwheel: false,
				fullscreenControl: false,
				zoomControl: opts.zoomControl
			};

			var final_config = Object.merge(default_config, config);
			var service = this.service = new google.maps.StreetViewService();

			if (final_config.pov && Object.keys(final_config.pov).length) {
				this.init_pano(final_config);
			} else {
				var panoRequest = {
					location: final_config.position,
					preference: google.maps.StreetViewPreference.NEAREST,
					radius: final_config.radius || 50,
					source: google.maps.StreetViewSource.OUTDOOR
				};
				service.getPanorama(panoRequest, function (pano_data, status) {
					if (status == google.maps.StreetViewStatus.OK) {
						var angle = this.compute_angle(final_config.position, pano_data.location.latLng);

						final_config.pov = {
							'heading': angle,
							'pitch': 0,
							'zoom': 1,
							'pano_data': pano_data
						};
					} else {
						final_config.pov = null;
					}
					this.init_pano(final_config);
				}.bind(this));
			}
		}
	},

	check_webgl: function check_webgl() {
		var canvas = new Element('canvas'),
		    contextNames = ["webgl", "experimental-webgl", "moz-webgl", "webkit-3d"],
		    gl = null;

		contextNames.each(function (e, i) {
			if (!gl) {
				try {
					gl = canvas.getContext(contextNames[i]);
				} catch (e) {}
			}
		});

		canvas = null;

		if (gl === null) this.mode = 'html4';
	},

	init_pano: function init_pano(config) {
		if (config.pov.pano_data.location.pano) {
			config.pano = config.pov.pano_data.location.pano;
		}
		var pano = this.pano = new google.maps.StreetViewPanorama(this._pano, Object.merge(config, { visible: true }));

		var marker_config = {
			'position': config.position,
			'clickable': false,
			'map': pano
		};

		if (config.marker) {
			marker_config = Object.merge(marker_config, config.marker);
		}

		this.base_marker = new google.maps.Marker(marker_config);
	},

	compute_angle: function compute_angle(end, start) {
		var DEGREE_PER_RADIAN = 57.2957795;
		var RADIAN_PER_DEGREE = 0.017453;
		var dlat = end.lat() - start.lat();
		var dlng = end.lng() - start.lng();
		var angle = Math.atan2(dlng * Math.cos(end.lat() * RADIAN_PER_DEGREE), dlat) * DEGREE_PER_RADIAN;

		if (angle >= 360) {
			angle -= 360;
		} else if (angle < 0) {
			angle += 360;
		}
		return angle;
	}
});
'use strict';

var Bars = new Class({
	Implements: Options,
	options: {
		cls: 'w_bars',
		tracking_label: ''
	},

	initialize: function initialize(_element, options) {
		this._element = _element || document.getElement('.' + this.options.cls);

		if (!this._element) return;

		this.setOptions(options);
		this.build();
	},

	build: function build() {
		//Core.add_autoplay_support();
		Core.add_froogaloop();
		this.set_player();

		window.addEvent('beforeunload', function (e) {
			this.players.each(function (player, i) {
				this.track_video(player, 'times');
				this.track_video(player, 'percent');
			}.bind(this));
		}.bind(this));
	},

	set_player: function set_player() {
		var _iframes = document.getElements('iframe');
		this.players = [];

		if (!_iframes) return;

		_iframes.each(function (_iframe, i) {
			this.players[i] = Froogaloop(_iframe);

			this.players[i].addEvent('ready', function () {
				this.handle_ready();
			}.bind(this));
		}.bind(this));
	},

	handle_ready: function handle_ready() {
		var self = this;
		this.players.each(function (player, i) {
			player.api('setVolume', 0);
			//player.api('play');
			player.counter = 1;

			player.addEvent('playProgress', function (data) {
				self.handle_play(player, data);
			});
		});
	},

	handle_play: function handle_play(player, data) {
		if (player.vimeo_data && player.vimeo_data.seconds > data.seconds) {
			player.counter++;
		}

		player.vimeo_data = data;
	},

	track_video: function track_video(player, type) {
		if (!player || !player.vimeo_data) return;

		var val;
		var src = player.element.get('src').split('?');

		if (type == 'percent') {
			val = (player.vimeo_data.percent * 100).round(2);
			val = 'Played Video: ' + val.toString() + '%';
		} else if (type == 'times') {
			val = 'Played Counts: ' + player.counter;
		}

		_gaq.push(['_trackEvent', this.options.tracking_label, val, src[0]]);
	},

	play: function play(player) {
		player.api('play');
	},

	pause: function pause(player) {
		player.api('pause');
	}
});
'use strict';

var BlimpExtPricehistory = new Class({
	Extends: BlimpExt,

	post_process_build: function post_process_build() {
		var _table = this._element.getElement('.w_pricehistory_table') || this._element.getElement('.w_pricehistory_fullscreen_table');;
		var tbody = _table.getElement('.tbody');

		if (this.is_initialized) {
			return;
		}

		if (this.options.page === 'lst' || this.options.vscroll) {
			new StyledScroll(tbody, {
				type: 'v',
				max_height: 300
			});
		}

		var _diagram = this._element.getElement('.diagram');

		if (_diagram) {
			_diagram.setStyle('height', _table.getSize().y);

			var data = JSONMOO.decode(_diagram.get('html'), false);

			_diagram.set('html', '');

			new Phgraph(_diagram, {
				'size': 'small',
				'data': data.reverse() // need to reverse the order so it will be display properly in the chart
			});
		}

		this.parent();
		this.is_initialized = true;
	}

});
'use strict';

var Tabscroll = new Class({
	Implements: [Options, Events],
	options: {
		cls: 'w_tabscroll'
	},

	initialize: function initialize(_element, options) {
		this._element = document.id(_element);

		if (this._element) {
			this.setOptions(options);
			this.build();
		}
	},

	build: function build() {
		var fcls = '.' + this.options.cls;
		var _element = document.id(this);

		this._tabs = _element.getElements(fcls + '_tabs li');
		this._content = _element.getElement(fcls + '_content');
		this._strip = _element.getElement(fcls + '_strip');
		this._items = _element.getElements(fcls + '_item');
		this.fx_items = [];

		this.active_index = 0;

		if (!this._items || this._items.length == 0) {
			this._element.dispose();
			return;
		}

		this.fx_scroll = new Fx.Scroll(this._content, {
			duration: 500,
			link: 'cancel'
		});

		this._tabs.each(function (_el, i) {
			_el.addEvent('click', this.select.bind(this, _el, i));

			if (this._tabs.length == 1) {
				_el.addClass('_full_width');
			} else if (i == 0) {
				_el.addClass('_first');
			} else if (i == this._items.length - 1) {
				_el.addClass('_last');
			}

			this.fx_items.push(new Fx.Morph(this._items[i], {
				duration: 1000,
				link: 'cancel'
			}));

			if (_el.hasClass('active') && i > 0 && this._items.length > 1) {
				this.select(_el, i);
			}
		}.bind(this));
	},

	select: function select(_tab, i, e) {
		if (e && e.stop) e.stop();

		if (this.active_index == i) return;

		this._tabs[this.active_index].removeClass('active');
		this.active_index = i;

		this._tabs[i].addClass('active');
		this.fx_scroll.toElement(this._items[i]);

		this.fx_items[i].start({
			opacity: [0, 1]
		});

		this.fireEvent('tabchange', i);
	},

	toElement: function toElement() {
		return this._element;
	}
});
'use strict';

var Schools = new Class({
	Implements: [Events, Options],
	options: {
		cls: 'w_schools',
		customId: 'schools'
	},

	initialize: function initialize(element, options) {
		this.setOptions(options);
		this._element = element;

		if (this._element) this.build();
	},

	build: function build() {
		var self = this;
		var rpc = this._element.get('data-rpc');

		if (rpc) {
			var remote = new Request.HTML({
				url: rpc,
				onSuccess: function onSuccess(a, b, c, d) {
					if (c === "") {
						self._element.getParent().dispose();
						return;
					}

					this.data = c;
					self._element.set('html', this.data);

					new Tabscroll(self.options.customId);

					var _shrinkers = self._element.getElements('.w_shrinker');

					_shrinkers.each(function (_shrinker) {
						var min_height = 270;

						new Shrinker(_shrinker, {
							min_height: min_height,
							toggler: _shrinker.getParent('.w_tabscroll_item').getElement('.w_shrinker_head'),
							single_opened: false,

							onShrink: function onShrink() {
								this._toggler.removeClass('_opened');
								this._toggler.set('html', '<span class="w_shrinker_button">Show more</span>');
							},

							onUnshrink: function onUnshrink() {
								this._toggler.addClass('_opened');
								this._toggler.set('html', '<span class="w_shrinker_button">Show less</span>');
							}
						});
					});
				},

				onFailure: function onFailure() {
					self._element.getParent().dispose();
				}
			});

			remote.get();
		}
	}
});
'use strict';

/*
---
description: FED Process
authors:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
provides: [LazyLoader]
...
*/
var ColumnChart = new Class({
	Implements: [Events, Options],

	options: {
		cls: 'w_columnchart',
		max_value: 0,
		increment: 100, //increment of the scale
		height: 500, //it's not a total height of the chart, it's height of it's scale
		disp_col: 5, //amount of displayed columns
		scroll_speed: 300,
		animate_values: true,
		scroll_at_a_time: 3, //how many items scroll at a time
		y_axis: '', //displayed name of y axis
		hscroll: true,
		zebra: true, //zebra background
		has_images: true,
		main_item_indicator: false, //horisontal dashed line
		scale_px_increment: 30,
		data: null,
		isBuilding: false,
		missingImage: null
	},

	initialize: function initialize(_element, options) {
		this.setOptions(options);

		this._element = _element || document.getElement('.' + this.options.cls);
		this._element.addClass('_loading');

		if (this._element) {
			this.build();
		}
	},

	build: function build() {
		var opts = this.options;

		if (Core.is_ie8()) {
			this._element.addClass('ie');
		}

		this.max_value = opts.max_value;

		if (opts.y_axis != '') {
			this._y_axis = new Element('.y_axis', { 'html': '<div class="vertical_text">' + opts.y_axis + '</div>' }).inject(this._element);
		}

		this._chart = new Element('.chart').inject(this._element);

		if (opts.zebra) {
			this._zebra = new Element('.zebra').inject(this._chart);
		}

		this._scroller = new Element('.scroller').inject(this._chart);

		this._col_container = new Element('.col_container').inject(this._scroller);

		this.property = this._element.getProperty('data-property');
		this.y_axis_text = this._element.getProperty('data-yaxis-name');

		if (opts.data) {
			this.data = opts.data;
			this.process_rpc();
		} else {
			this.rpc_request();
		}

		this.add_functionalities();
	},

	add_hscroll: function add_hscroll() {
		var self = this;
		var opts = this.options;
		var _hscroll = this._hscroll = new Element('.hscroller', { 'html': '<div class="ar_l">&nbsp;</div><div class="dragger">|||</div><div class="ar_r">&nbsp;</div>' });
		_hscroll.inject(this._chart);

		this._element.addClass('_has_dragger');

		var _ar_l = this._ar_l = _hscroll.getElement('.ar_l');
		var _ar_r = this._ar_r = _hscroll.getElement('.ar_r');

		_ar_l.addEvent('click', function () {
			self._arr_prev.fireEvent('click');
		});

		_ar_r.addEvent('click', function () {
			self._arr_next.fireEvent('click');
		});

		var _dragger = this._dragger = _hscroll.getElement('.dragger'),
		    size_coefficient = this._items.length - opts.disp_col;

		this.dragger_fx = new Fx.Morph(_dragger, {
			link: 'cancel',
			duration: 1000,
			transition: Fx.Transitions.linear
		});

		if (size_coefficient > 20) {
			size_coefficient = 20;
		} else if (size_coefficient < 2) {
			size_coefficient = 2;
		}

		var dr_size = _hscroll.getSize().x / size_coefficient;

		_dragger.setStyle('width', dr_size);

		var max_left = self.dragger_max_left = _hscroll.getSize().x - dr_size,
		    dragger_left = max_left / (this._items.length - opts.disp_col) * this.current_col;

		if (this.current_col == 0) {
			_ar_l.addClass('inactive');
		} else if (this.current_col == this.last) {
			_ar_r.addClass('inactive');
		}

		(function () {
			self.dragger_fx.start({ 'left': dragger_left });
			self.dragger_fx.setOptions({ duration: self.options.scroll_speed });
		}).bind(this).delay(2000);

		_hscroll.addEvents({
			'mouseenter': function mouseenter() {
				if (self.dragging != true) self._element.addClass('dragging');
			},
			'mouseleave': function mouseleave() {
				if (self.dragging != true) self._element.removeClass('dragging');
			}
		});

		_dragger.addEvent('mousedown', function (e) {
			self.dragging = true;
			self._element.addClass('dragging');
			dragger_left = _dragger.getStyle('left').toInt();
			self.init_pos = e.page.x;
			return false;
		});

		$(document.body).addEvents({
			'mousemove': function mousemove(e) {
				if (self.dragging) {
					var hmove = e.page.x - self.init_pos,
					    left = dragger_left + hmove;

					if (left < 0) {
						left = 0;
					} else if (left > max_left) {
						left = max_left;
					}

					_dragger.setStyle('left', left);

					var area = self.drag_area = (left / (max_left / (self._items.length - opts.disp_col))).round();

					self.animate.set(left * ((self._col_container.getSize().x - self.scr_width) / max_left), 0);

					if (self.current_col != area) {
						self.current_col = area;

						if (area == 0) {
							self._arr_prev.addClass('inactive');
							_ar_l.addClass('inactive');
						} else {
							self._arr_prev.removeClass('inactive');
							_ar_l.removeClass('inactive');
						}

						if (area == self._items.length - opts.disp_col) {
							self._arr_next.addClass('inactive');
							_ar_r.addClass('inactive');
						} else {
							self._arr_next.removeClass('inactive');
							_ar_r.removeClass('inactive');
						}
					}

					self.hide_locked_item();
				}
			},

			'mouseleave': function mouseleave() {
				self.dragging = false;
				self._element.removeClass('dragging');
			},

			'mouseup': function mouseup() {
				self.dragging = false;
				self._element.removeClass('dragging');
			}
		});
	},

	create_scale: function create_scale() {
		this._scale = new Element('.scale');

		if (this._y_axis) {
			this._scale.inject(this._y_axis, 'after');
		} else {
			this._scale.inject(this._element, 'top');
		}

		var increment = this.options.increment;

		// Force the max_value to be rounded to the nearest increment
		this.max_value = Math.ceil(this.max_value / increment) * increment;

		// Calculate the number of increments that can fit into the chart height
		var numIncrements = Math.floor(this.options.height / this.options.scale_px_increment);
		increment = Math.ceil(this.max_value / numIncrements);

		var value = 0,
		    _el;

		this._values = [];

		// Adjust grid height based on the new increment value
		var grid_height = this.options.height / numIncrements;

		while (value <= this.max_value) {
			var grid_char = this.options.zebra ? '&bull;' : '-';
			var formattedValue = '$' + Core.add_commas(value);
			_el = new Element('.value', {
				'html': formattedValue + '<div class="grid">' + grid_char + '</div>',
				'styles': {
					'height': grid_height + 'px'
				}
			}).inject(this._scale, 'top');
			value += increment;

			this._values.push(_el);
		}

		this.options.height = grid_height * this._values.length;

		if (this._zebra) {
			var cls = '';
			this._values.each(function (_el, i) {
				var zebra_height = grid_height;

				if (cls == '') {
					cls = 'x';
					zebra_height -= 2; //dashed border of the zebra
				} else {
					cls = '';
				}

				var _strip = new Element('div', { 'class': cls });
				_strip.inject(this._zebra);
				_strip.setStyle('height', zebra_height);
			}.bind(this));

			var margin = this._scale.getElement('.grid').getCoordinates().top - this._chart.getCoordinates().top - this._scale.getElement('.grid').getStyle('margin-top').toInt();
			this._zebra.getElement('div').setStyle('margin-top', margin);
		} else {
			this._values.each(function (_el) {
				_el.setStyle('height', grid_height);
			});
		}

		var scale_height = this._scale.getSize().y - this._scale.getStyle('padding-top').toInt() + this._scale.getElement('.grid').getStyle('top').toInt();
		this._scale.setStyle('height', scale_height);

		var grid_width = this._chart.getComputedSize().computedBottom;
		this._scroller.setStyle('height', this._scale.getSize().y - grid_width);

		if (this._y_axis) {
			this._y_axis.setStyle('height', this._scale.getSize().y - grid_width);
		}

		this.set_prices();
	},

	set_prices: function set_prices() {
		var height;
		var price;

		this._items.each(function (e) {
			price = e.getAttribute('data-price').toInt();
			height = (price * this.options.height / this.max_value).round() - 1;

			if (this.options.animate_values == true) {
				e.setAttribute('data-height', height);
			} else {
				e.setStyle('height', height);
			}

			if (e.hasClass('main') && this._indicator) {
				this._indicator.setStyle('bottom', height).addClass('visible');
			}
		}.bind(this));
	},

	rpc_request: function rpc_request() {
		var self = this;

		if (!self.options.data) {
			new Remote({
				rpc: this._element.getAttribute('data-rpc'),
				method: 'get',
				onSuccess: function onSuccess() {
					self.data = this.get_data();
					self.process_rpc();

					document.fireEvent('columnChartLoaded');
				},
				onError: function onError() {
					this._element.set('html', 'Server connection error. Please try later');
				}
			});
		} else {
			self.process_rpc();
		}
	},

	process_rpc: function process_rpc() {
		this._items = [];
		var col_container_width = 0;

		if (this.data && this.data != '') {
			this.change_y_label();

			var notFoundImageUrls = ['/l/not-found-grey-gallery-1.png', '/l/not-found-grey-gallery-2.png', '/l/not-found-grey-gallery-3.png', '/l/not-found-grey-gallery-4.png', '/l/not-found-grey-gallery-5.png', '/l/not-found-grey-gallery-6.png', '/l/not-found-grey-gallery-7.png', '/l/not-found-grey-gallery-8.png'];
			var notFoundImageCnt = 0;

			this.data.each(function (e, i) {

				if (!e.thumbor_images || !!e.thumbor_images && e.thumbor_images.length == 0) {
					var _index = notFoundImageCnt % 8;
					e.notFoundImageUrl = Res_i + notFoundImageUrls[_index];
					notFoundImageCnt++;
				}

				var price = e[this.property];

				price = price.toInt();

				if (this.max_value < price) {
					this.max_value = price;
				}

				var img_path,
				    name = (e.name || e.address || e.building_name || e.building_address) + (e.unit ? ', #' + e.unit : ''),
				    cls = 'bld_item' + (e.current == true ? ' main' : ''),
				    html = '';

				if (e.current == true && this.options.main_item_indicator) {
					this._indicator = new Element('.indicator', { 'html': '<div class="pointer">&nbsp;</div>' }).inject(this._chart).fade('hide');
				}

				if (this.options.has_images) {
					img_path = this.options.tmp_img || e.image;

					html = '<img src="' + img_path + '"' + 'onerror="' + this.options.err_img + '"' + '/>';
				}
				var vt_html = '<div class="vt_container">' + '<div class="vertical_text">' + name + '</div>' + '</div>';

				var add_cls = this._element.getAttribute('data-open') && this._element.getAttribute('data-open') == 'page' ? '' : ' w_blimp_bld';

				var _bld_item = new Element('div', {
					'class': cls + add_cls,
					'html': html,
					'data-price': e[this.property],
					'data-class': 'w_blimp_bld'
				});

				this._items.push(_bld_item);

				_bld_item.addEvents({
					'mouseenter': function () {
						if (this.locked_item) {
							this.locked_item.removeClass('_active');
						}

						this.locked_item = _bld_item;
						this.locked_item.addClass('_active');
						this.bulb_show(e, _bld_item);
					}.bind(this)
				});

				// if(e.url_listing || e.url && e.url != ''){
				// 	_bld_item.set('data-rpc', e.url_listing || e.url);

				// 	if (this._element.getAttribute('data-open') && this._element.getAttribute('data-open') == 'page'){
				// 		_bld_item.addEvent('click', function(){ window.location = e.url_listing || e.url; });
				// 	}else{
				// 		new BlimpExt(_bld_item, {
				// 			draggable: true,
				// 			show_veil: true,
				// 			onPostRpc: function(){
				// 				new BldBlimp(this);
				// 			}
				// 		});
				// 	}
				// }

				var _column = new Element('div', {
					'class': 'column' + (i == this.data.length - 1 ? ' last' : ''),
					'html': vt_html
				}).adopt(_bld_item).inject(this._col_container);

				var col_w = _column.getComputedSize().width,
				    col_m = _column.getStyle('margin-right').toInt();

				col_container_width += col_w + col_m;

				if (!this.scroll_w_is_set) {
					this.set_scroll_width(col_w, col_m);
					this.scroll_w_is_set = true;
				}
			}.bind(this));

			(function () {
				this._col_container.setStyle('width', col_container_width);
			}).delay(500, this);

			this._main_col = this._scroller.getElement('.main');

			if (this._main_col) {
				this._init_scroll = this._main_col.getParent('.column');
			} else {
				//this.fireEvent('notEnoughData');
			}

			this.create_scale();

			if (this._scroller.getStyle('width').toInt() < col_container_width) {
				this.add_scrolling();
			}

			if (this.options.animate_values == true) {
				this.animate_prices();
			} else {
				if (this._indicator && this._indicator.hasClass('visible')) {
					this._indicator.fade('show');
				}
			}

			this._bulb = new Element('.' + this.options.cls + '_bulb', {
				'html': '<div class="pointer">&nbsp;</div>'
			}).inject(this._element);

			this._bulb.addClass('clearfix');

			if (!this.options.isBuilding) {
				this._bulb.addClass('_listings');
			} else {
				this._bulb.addClass('_buildings');
				this._info = new Element('div.info').inject(this._bulb, 'top');

				var content = this._info;
				this._bulb_name = new Element('a.name').inject(content);
				this._bulb_address = new Element('a.address').inject(content);
				this._bulb_details = new Element('span.details').inject(content);
				this._bulb_available_for_sale = new Element('a.apts_for_sale').inject(content);
				this._bulb_available_for_rent = new Element('a.apts_for_rent').inject(content);
				this._bulb_size = new Element('span.size').inject(content);
				this._bulb_created = new Element('span.created').inject(content);
				this._bulb_updated = new Element('span.updated').inject(content);
				var grey_box = new Element('div.grey-box').inject(content);
				this._bulb_price = new Element('span.price').inject(grey_box);
				this._bulb_sales = new Element('span.sales').inject(grey_box);
			}

			this._chart.setStyle('visibility', 'visible');

			if (this._y_axis) {
				this._y_axis.setStyle('visibility', 'visible');
			}
		} else {
			this.fireEvent('noData');
		}

		this._element.removeClass('_loading');
	},

	change_y_label: function change_y_label() {
		if (!this._y_axis) return;

		this._y_axis.getElement('.vertical_text').set('html', this.y_axis_text);
	},

	set_scroll_width: function set_scroll_width(w, m) {
		var dc = this.options.disp_col,
		    width = this.scr_width = w * dc + m * (dc - 1) - 100;

		this._scroller.setStyle('width', width);
	},

	bulb_show: function bulb_show(data, _el) {
		if (this._save_tooltip) {
			this._save_tooltip.hide();
		}
		if (this.bubble_is_ready && this.dragging != true) {
			if (!this.options.isBuilding) {
				this.add_listing_tile(data);
			} else {

				var add_text = this.property == 'ppsqft' || this.property == 'sqft' ? ' /ft<sup>2</sup>' : '';
				var price = data[this.property];

				var transactions = data.transactions || 0;
				var str_sales = transactions > 1 ? 'sales' : 'sale';

				this._bulb_sales.set('html', 'Based on ' + transactions + ' ' + str_sales + '<br/>in past 12 months');

				if (data.sale && data.sale.available > 0) {
					var apts = data.sale.available > 1 ? ' Apartments' : ' Apartment';
					if (data.sale.min == data.sale.max) {
						this._bulb_available_for_sale.set('html', '<strong>' + data.sale.available + apts + ' for Sale</strong> for $' + Core.short_number(data.sale.min));
					} else {
						this._bulb_available_for_sale.set('html', '<strong>' + data.sale.available + apts + ' for Sale</strong> ($' + Core.short_number(data.sale.min) + ' - $' + Core.short_number(data.sale.max) + ')');
					}
					this._bulb_available_for_sale.removeEvents().addEvent('click', function (e) {
						e.stopPropagation();
						Cookie.write('crBovJumpTo', 'sale');
						window.location = data.building_url;
					});
				} else {
					this._bulb_available_for_sale.set('html', '');
				}

				if (data.rent && data.rent.available > 0) {
					var apts = data.rent.available > 1 ? ' Apartments' : ' Apartment';
					if (data.rent.min == data.rent.max) {
						this._bulb_available_for_rent.set('html', '<strong>' + data.rent.available + apts + ' for Rent</strong> for $' + Core.add_commas(data.rent.min));
					} else {
						this._bulb_available_for_rent.set('html', '<strong>' + data.rent.available + apts + ' for Rent</strong> ($' + Core.add_commas(data.rent.min) + ' - $' + Core.add_commas(data.rent.max) + ')');
					}
					this._bulb_available_for_rent.removeEvents().addEvent('click', function (e) {
						e.stopPropagation();
						Cookie.write('crBovJumpTo', 'rent');
						window.location = data.building_url;
					});
				} else {
					this._bulb_available_for_rent.set('html', '');
				}

				this._bulb_price.set('html', '$' + Core.add_commas(price) + add_text);
				this._bulb_name.set('text', (data.name || data.address || data.building_name || data.building_address) + (data.unit ? ', #' + data.unit : ''));
				this._bulb_name.set('href', data.url_listing || data.url || data.building_url);

				if (data.sqft) {
					this._bulb_size.set('html', 'Approx. ' + data.sqft + ' ft<sup>2</sup>');
				}
				// if (data.listing_added) {
				// 	this._bulb_created.set('text', 'Listed ' + data.listing_added);
				// }
				// if (data.listing_updated) {
				// 	this._bulb_updated.set('text', 'Updated ' + data.listing_updated);
				// }

				if (data.name || data.building_name) {
					if (data.address || data.building_address) {
						this._bulb_address.set('text', data.address || data.building_address);
					}
					if (data.url || data.building_url) {
						this._bulb_address.set('href', data.url_listing || data.url || data.building_url);
					}
					this._bulb_address.show();
				} else {
					this._bulb_address.hide();
				}

				if (this.options.isBuilding) {
					this._bulb.set('data-class', 'w_blimp_bld');
					this._bulb.set('href', data.url);

					new BlimpExt(this._bulb, {
						draggable: true,
						show_veil: true,
						onPostRpc: function onPostRpc() {
							new BldBlimp(this);
						}
					});
				}

				if (this._bulb_ppsqft && data["ppsqft"] != null) {
					this._bulb_ppsqft.set('html', '$' + Core.add_commas(data["ppsqft"]) + ' /ft<sup>2</sup>');
				} else {
					if (this._bulb_ppsqft) {
						this._bulb_ppsqft.setStyle('display', 'none');
					}
				}

				this._bulb_details.set('text', data.beds_baths);
				this.add_save_support(data);
			}

			var v_pos = _el.getStyle('height').toInt() + this._bulb.getElement('.pointer').getStyle('height').toInt() + this._element.getComputedSize().computedBottom + 1 /*border*/
			,
			    h_pos = _el.getCoordinates().left - this._element.getCoordinates().left - this._bulb.getStyle('width').toInt() / 2 - this._bulb.getStyle('padding-left').toInt() + _el.getCoordinates().width / 2;

			this._bulb.setStyles({
				'bottom': v_pos,
				'left': h_pos > 400 ? h_pos - 160 : h_pos + 160
			});
			if (h_pos > 400) {
				this._bulb.addClass('right-bulb');
			} else {
				this._bulb.removeClass('right-bulb');
			}

			this._bulb.show();
		}
	},

	add_listing_tile: function add_listing_tile(data) {
		// for listings
		if (!this.options.isBuilding) {
			if (this.listingTile) {
				// dont do anything if the user mouseover to the last active listing again
				if (this.listingTile.hasClass('_' + data.mask_id)) {
					return;
				}

				// remove the current save button
				this.listingTile.dispose();
			}

			if (data.listingTile) {
				data.listingTile.inject(this._bulb);
			} else {
				data.contact = '';
				data.listingTile = new Element('<cr-listing-tile', {
					'class': 'cr-listing-tile' + ' _' + data.mask_id,
					'data-rpc': data.url_v2,
					'data-open-blimp-on-click': true,
					'data-missing-image': this.options.missingImage,
					'data-rpc-save-to-profile': this.options.rpcSaveToProfile,
					'html': '<div class="hidden none obj-wrapper">' + JSONMOO.encode(data) + '</div>'
				}).inject(this._bulb);

				Core.compile_html(data.listingTile);
			}

			this.listingTile = data.listingTile;
		}
	},

	add_save_support: function add_save_support(data) {
		if (this.currentSaveButton) {
			var id = this.options.isBuilding ? data.building_id : data.mask_id;
			// dont do anything if the user mouseover to the last active listing again
			if (this.currentSaveButton.hasClass('_' + id)) {
				return;
			}
			// remove the current save button
			this.currentSaveButton.dispose();
		}

		this.currentSaveButton = data.crSaveToProfile;
	},

	bulb_hide: function bulb_hide() {
		if (this._save_tooltip) {
			this._save_tooltip.hide();
		}
		this._bulb.hide();
	},

	add_scrolling: function add_scrolling() {
		this._arr_prev = new Element('.arr_prev');
		this._arr_next = new Element('.arr_next');

		this._columns = this._scroller.getElements('.column');
		this.current_col = 0;

		this._arr_prev.inject(this._chart);
		this._arr_next.inject(this._chart);

		this.animate = new Fx.Scroll(this._scroller, {
			link: 'cancel',
			duration: 1000,
			transition: Fx.Transitions.Quad.easeOut,
			onStart: function () {
				this.hide_locked_item();
			}.bind(this)
		});

		if (this._init_scroll) {
			this._columns.each(function (_el, i) {
				if (_el === this._init_scroll) {
					var half = Math.ceil(this.options.disp_col / 2);

					if (i < half) {
						this.current_col = 0;
						this._arr_prev.addClass('inactive');
					} else if (this._columns.length - i <= half) {
						this.current_col = this._columns.length - this.options.disp_col;
						this._arr_next.addClass('inactive');
					} else {
						this.current_col = i - half + 1;
					}
				}
			}.bind(this));
		} else {
			this._arr_prev.addClass('inactive');
			this.current_col = 0;
		}

		(function () {
			this.animate.toElement(this._columns[this.current_col]).chain(function () {
				this._arr_prev.addEvent('click', this.scroll_prev.bind(this));
				this._arr_next.addEvent('click', this.scroll_next.bind(this));
			}.bind(this));
			this.animate.setOptions({ duration: this.options.scroll_speed });
		}).bind(this).delay(2000);

		this.last = this._columns.length - this.options.disp_col;

		if (this.options.hscroll == true) {
			this.add_hscroll();
		}
	},

	animate_prices: function animate_prices() {
		if (!this.current_col) this.current_col = 0;

		var last_visible = Math.min(this.current_col + this.options.disp_col - 1, this._items.length - 1);
		var speed = 2000;

		this._items.each(function (_el, i) {
			var height = _el.getAttribute('data-height');

			if (i >= this.current_col && i <= last_visible) {
				var sc = speed * _el.getAttribute('data-price').toInt() / this.max_value,
				    //speed coefficient
				delay = (i >= this.current_col ? i - this.current_col : 0) * 100 + 100;

				(function () {
					var tween = new Fx.Morph(_el, { duration: sc, transition: Fx.Transitions.Bounce.easeOut });
					tween.start({ 'height': [0, height] });
				}).delay(delay);
			} else {
				(function () {
					_el.setStyle('height', height.toInt());
				}).delay(500);
			}
		}.bind(this));

		(function () {
			this.bubble_is_ready = true;

			if (this._indicator && this._indicator.hasClass('visible')) {
				this._indicator.fade('in');
			}
		}).bind(this).delay(speed);
	},

	scroll_prev: function scroll_prev() {
		var prev = this.current_col - this.options.scroll_at_a_time;

		if (prev > 0) {
			this.animate.toElement(this._columns[prev]);
			this.current_col -= this.options.scroll_at_a_time;
		} else {
			this.animate.toElement(this._columns[0]);
			this._arr_prev.addClass('inactive');
			this._ar_l.addClass('inactive');
			this.current_col = 0;
		}

		if (this._dragger) {
			var left = this.dragger_max_left / (this._items.length - this.options.disp_col) * this.current_col;
			this.dragger_fx.start({ 'left': left });
		}

		this._arr_next.removeClass('inactive');
		if (this._ar_r) {
			this._ar_r.removeClass('inactive');
		}
	},

	scroll_next: function scroll_next() {
		var next = this.current_col + this.options.scroll_at_a_time;

		if (next < this.last) {
			this.animate.toElement(this._columns[next]);
			this.current_col += this.options.scroll_at_a_time;
		} else {
			this.animate.toElement(this._columns[this.last]);
			this._arr_next.addClass('inactive');
			this._ar_r.addClass('inactive');
			this.current_col = this.last;
		}

		if (this._dragger) {
			var left = this.dragger_max_left / (this._items.length - this.options.disp_col) * this.current_col;
			this.dragger_fx.start({ 'left': left });
		}

		this._arr_prev.removeClass('inactive');
		if (this._ar_l) {
			this._ar_l.removeClass('inactive');
		}
	},

	add_functionalities: function add_functionalities() {
		var self = this;
		this._element.addEvents({
			'mouseenter': function mouseenter() {
				self._element.addClass('_hover');
			},
			'mouseleave': function mouseleave() {
				self._element.removeClass('_hover');
				self.hide_locked_item();
			}
		});
	},

	hide_locked_item: function hide_locked_item() {
		if (this.locked_item) {
			this.bulb_hide();
			this.locked_item.removeClass('_active');
		}
	}
});
'use strict';

Page.Hom = new Class({
	initialize: function initialize() {
		this.track_campaign();
		this.previous_page_id = Core.get_previous_page_id();

		Core.to_mobile_link();

		Core.set_content_position();

		new ImgLazyLoad({
			container: document.getElement('.scrolling_content'),
			range: 300
		});

		this.preload_featured();

		this._content = document.getElement('.scrolling_content');

		this.run_content_js();

		this.bottom_bar();

		Core.add_signin_support();

		Core.add_stalker_support({});

		this.add_userTools();

		Core.add_select_support();
		Core.add_contact_support();

		Core.get_previous_page_id();
		Core.clear_sales_data_cookies();
		Core.add_footer_support();
		Core.add_broker_toggle_support();

		Core.init_recaptcha();

		this.handleHash();

		crMonitor.end('executionTime');
	},
	add_cards_support: function add_cards_support() {
		var self = this;
		var _cards = this._content.getElements('.w_card');
		_cards.each(function (_el) {
			new Card(_el, {
				transition_duration: 800
			});
		});
	},
	track_campaign: function track_campaign() {
		var campaignVersion = Cookie.read('crTrackCampaign');
		if (campaignVersion) {
			campaignVersion = campaignVersion.toUpperCase();
			var name = "open-popup-initial-adwords" + campaignVersion;
			var action = 'member-redirect';
			if (campaignVersion === 'E') {
				if (G) {
					action = "non-registered";
				} else {
					action = "member";
				}
			}
			_gaq.push(['_trackEvent', 'Registration', name, action]);
			Cookie.dispose('crTrackCampaign');
		}
	},
	preload_featured: function preload_featured() {
		var _card = document.getElement('.w_card');

		if (!_card) return;

		var _imgs = _card.getElements('img');
		var urls = [];

		_imgs.each(function (_el) {
			var dataImage = _el.getAttribute('data-image');
			if (dataImage) {
				urls.push(dataImage);
			}
		});

		Asset.images(urls);
	},

	bottom_bar: function bottom_bar() {
		var spotlightSection = document.getElement('.spotlight');
		Core.bottom_bar(spotlightSection, 150);
	},

	add_userTools: function add_userTools() {
		new UserTools(document.getElement('.w_stalker'));
	},

	run_content_js: function run_content_js() {
		if (this.content_js_is_there) return;

		this.content_js_is_there = true;

		this.add_cards_support(); //for ad gallery
		this.add_graphs_scroller(); //for stats.php

		this.add_pricing_history(); //for stats.php

		this.add_signup_support(); //for sign-up.php
		this.add_cr_banner_support(); // for why-use-cityrealty
	},

	add_signup_support: function add_signup_support() {
		var _sign_section = document.getElement('.sign_up');
		if (_sign_section) {
			_sign_section.removeClass('none');
			Core.add_signout_support(_sign_section);
		}
	},

	add_graphs_scroller: function add_graphs_scroller() {
		var self = this;
		var _stats = document.getElement('.statistics');

		if (!_stats) return;

		_stats.removeClass('none');

		var _cont = _stats.getElement('.graphs_cont');
		var scroll = new Fx.Scroll(_cont);
		var jump = new Fx.Scroll(_cont, { duration: 0 });
		var _graph_items = _stats.getElements('.graphs .item');

		new Page.Hom.FlexWidth(_cont.getElement('.graphs'));

		var _active_graph = _graph_items[0];

		new Toggle(_stats.getElement('.w_toggle'), {
			onToggle: function onToggle(_el) {
				var index = _el.getAttribute('data-value').toInt();

				if (index === 1 && !self.market_snapshot_loaded) {
					self.add_market_snapshot();
					self.market_snapshot_loaded = true;
				} else if (index === 2 && !self.top_condos_loaded) {
					self.add_top_condos();
					self.top_condos_loaded = true;
				}

				scroll.toElement(_graph_items[index]);
				_active_graph = _graph_items[index];
				// element in inactive slides should not be
				// able to receive focus;
				_graph_items.forEach(function (d) {
					if (d !== _active_graph) d.style.visibility = 'hidden';else {
						d.style.visibility = 'visible';
					}
				});
			}
		});

		window.addEvents({
			'resize': function resize() {
				if (!_active_graph) return;

				jump.toElement(_active_graph);
			},

			'orientationchange': function orientationchange() {
				window.fireEvent('resize');
			}
		});
	},

	add_market_snapshot: function add_market_snapshot() {
		new Page.Hom.MarketSnapshotGraph();
	},

	add_top_condos: function add_top_condos() {
		var _container = document.getElement('._top_condos');

		if (!_container) return;

		var _graph = _container.getElement('.graph');
		var url = _container.getAttribute('data-rpc');

		var data_periods, data_zones;

		var _period_select = _container.getElement('select');

		function __display_data(period) {
			if (data_periods && data_zones) {
				_graph.empty();

				new Page.Hom.Multigraph(_graph, {
					data: {
						zones: data_zones,
						data: data_periods[period]
					}
				});
			}
		}

		if (_period_select) {
			_period_select.addEvent('change', function (e) {
				var period = e.getAttribute('data-period') || 5;
				__display_data(period);
			});
		}

		new Request.JSON({
			url: url,
			method: 'get',

			onSuccess: function onSuccess(data) {
				data_periods = data.data;
				data_zones = data.zones;

				var period = _period_select ? _period_select.getElement(':selected').getAttribute('data-period') : '12m';
				__display_data(period);
			}
		}).send();
	},

	add_pricing_history: function add_pricing_history() {
		new Page.Hom.PricingHistoryGraph(document.getElement('.graphs ._pricing_history'));
	},

	add_cr_banner_support: function add_cr_banner_support() {
		var _why_use_cr = document.getElement('.why_use_cityrealty');

		if (!_why_use_cr) {
			return;
		}

		var _video = _why_use_cr.getElement('._video');

		if (_video) {
			_why_use_cr.crVideo = new Bars(_video);
		}
	},

	handleHash: function handleHash() {
		if (window.location.hash) {
			var hash = window.location.hash.substring(1);
			if (hash.indexOf("contact-us") !== -1) {
				document.querySelector(".w_blimp_contact_us").click();
			}
		}
	}
});

Page.Hom.Multigraph = new Class({
	Implements: [Events, Options],

	options: {
		cls: 'w_multigraph',
		data: null
	},

	initialize: function initialize(_element, options) {
		this._element = _element || document.getElement('.' + this.options.cls);

		if (!this._element) return;

		this.setOptions(options);

		this.build();
	},

	build: function build() {
		var data = this.options.data;

		this.zones = data.zones;
		this.data = data.data;

		if (!data || this.data.length == 0) return;

		var self = this;
		this.zones_amount = 0;

		this.values = [];

		Object.each(this.zones, function (el, i) {
			var zone_data = self.data[i];

			if (zone_data && zone_data.length > 0 && i != 12 && i != 5) {
				self.zones_amount++;

				zone_data.each(function (e) {
					if (self.values.indexOf(e.sold_ppsqft) < 0) {
						self.values.push(e.sold_ppsqft);
					}
				});
			}
		});

		this.values.sort(function (a, b) {
			return a - b;
		});

		this.create_initial_markup();

		this.order_zones();
		this.create_graphs();
		this.create_y_scale();
	},

	create_initial_markup: function create_initial_markup() {
		this._element.addClass('clearfix');

		this._graphs_container = new Element('.graphs');

		this._graphs_container.setStyles({
			width: '95%',
			float: 'right'
		});

		this._graphs_container.inject(this._element);

		var _veil = new Element('.veil', {
			'html': '&nbsp;'
		});

		_veil.inject(this._element);
	},

	create_y_scale: function create_y_scale() {
		var _y_scale = new Element('.y_scale');

		_y_scale.setStyles({
			height: this._element.getElement('.col').getSize().y,
			position: 'absolute',
			left: 0,
			right: 0,
			top: this._element.getElement('.col').getStyle('top')
		});

		_y_scale.inject(this._element, 'top');

		var min = this.values[0];
		var max = this.values[this.values.length - 1];
		var val = 0;
		var diff = Math.round((max - min) / 5);

		while (val < max) {
			if (val > min) {
				var _line = new Element('dashed_line', { html: '$' + Core.add_commas(val) }).inject(_y_scale, 'top');

				_line.setStyles({
					'borderBottom': '1px dashed #ccc',
					'textAlign': 'left',
					'paddingLeft': 20,
					'position': 'absolute',
					'left': 0,
					'right': 0,
					'bottom': (val - min) * 100 / (max - min) + '%'
				});
			}

			val += diff;
		}
	},

	order_zones: function order_zones() {
		if (this.zones_amount == 0) return;

		this.graph_width = 100 / this.zones_amount;

		this.ordered_zones = [[2, this.data[2] || []], [1, this.data[1] || []], [11, this.data[11] || []], [3, this.data[3] || []], [13, this.data[13] || []], [4, this.data[4] || []]];
	},

	create_graphs: function create_graphs(options) {
		var self = this;
		var first = true;

		this.ordered_zones.each(function (el, i) {
			if (el[1] && el[1].length > 0) {
				var options = {
					name: self.zones[el[0]],
					data: el[1],
					min: self.values[0],
					max: self.values[self.values.length - 1],
					width: self.graph_width + '%',
					add_class: first ? '_first' : '',
					container: self._graphs_container,
					veil: self._element.getElement('.veil')
				};

				new Page.Hom.Multigraph.Section(options);

				first = false;
			}
		});
	}
});

Page.Hom.Multigraph.Section = new Class({
	Implements: [Events, Options],

	options: {
		name: '',
		data: null,
		min: 0,
		max: 100,
		width: '20%',
		padding_top: 30,
		padding_bottom: 30,
		add_class: '',
		veil: null,
		dot_styles: {
			cursor: 'pointer',
			overflow: 'hidden',
			backgroundColor: '#c13f61',
			height: 36,
			width: 36,
			borderRadius: '50%',
			border: '3px solid #fff',
			position: 'absolute',
			left: '50%',
			marginLeft: -21,
			marginTop: -21,
			top: 0
		},
		container: null
	},

	initialize: function initialize(options) {
		this.setOptions(options);

		var opts = this.options;
		this.data = opts.data;

		this._element = new Element('.zone', {
			html: '<div class="zone_graph clearfix"></div><h3>' + opts.name + '</h3>'
		});

		if (opts.add_class != '') {
			this._element.addClass(opts.add_class);
		}

		if (opts.container) {
			this._element.inject(opts.container);
		}

		this._graph = this._element.getElement('.zone_graph');

		this._element.setStyles({
			width: opts.width,
			float: 'left'
		});

		this.put_data_on_graph();

		var easytips = new EasyTips(this._element.getElements('.marker'), {
			position: this._element.hasClass('_first') ? 'right' : 'left',
			content: function content(_el) {
				return _el.getElement('.bld_tip');
			},
			onShow: function onShow() {
				var page_top = document.body.getScroll().y,
				    tooltip_top = easytips._tt_content.getCoordinates().top,
				    diff = page_top - tooltip_top;

				easytips._tt_tail.ini_mt = easytips._tt_tail.ini_mt || easytips._tt_tail.getStyle('margin-top').toInt();

				var tail_mt = easytips._tt_tail.ini_mt;
				var _img = easytips._tt_content.getElement('img');
				var src = _img.getProperty('data-src');

				var deduction = 0;

				if (Core.is_ie11()) {
					deduction = 20;
				}

				if (diff > 0) {
					_img.set('src', src);
					easytips._container.setStyle('top', page_top);
					tail_mt -= diff;
					tail_mt -= deduction;

					easytips._tt_tail.setStyle('margin-top', tail_mt);
				} else {
					new Asset.image(src, {
						onLoad: function onLoad() {
							_img.set('src', src);
							var page_bottom = page_top + window.getSize().y;
							var tooltip_height = easytips._tt_content.getSize().y;
							var tooltip_bottom = tooltip_top + tooltip_height;

							diff = tooltip_bottom - page_bottom;

							if (diff > 0) {
								easytips._container.setStyle('top', page_bottom - tooltip_height);
								tail_mt += diff;
								tail_mt -= deduction;
							}

							easytips._tt_tail.setStyle('margin-top', tail_mt);
						}
					});
				}
			}
		});
	},

	put_data_on_graph: function put_data_on_graph() {
		var self = this;
		var opts = this.options;
		var _veil = opts.veil || this._element.getParent().getElement('.veil');

		this.data.each(function (el) {
			var _column = new Element('.col').inject(self._graph);

			_column.setStyles({
				width: 100 / self.data.length + '%',
				height: '86%',
				top: '7%',
				float: 'left',
				position: 'relative'
			});

			var _marker = new Element('.marker', {
				'data-class': 'w_blimp'
			}).inject(_column);

			var _tooltip = new Element('div', {
				'class': 'bld_tip clearfix',
				'data-url': el.url,
				'html': '<div class="image_holder">' + '<img src="' + el.image + '" data-src="' + el.image + '"onerror="this.src=\'' + Res_i + '\/l/missing.png\';" />' + '</div>' + '<div class="tip_title">' + (el.name || el.address) + '</div>' + (el.name && el.name != '' ? '<div class="address">' + el.address + '</div>' : '') + '<a class="raquo">Full Building Info</a>' + (el.sold_ppsqft && el.sold_ppsqft > 0 ? '<div class="price">' + '<strong><span class="small">$</span>' + Core.add_commas(Math.round(el.sold_ppsqft)) + '</strong>' + '<span>Sold Price / Ft<sup>2</sup></span>' + '</div>' : '') + '<div class="clearfix">' + (el.available && el.available > 0 ? '<div class="apts">' + '<strong>' + el.available + '</strong>' + '<span>Apts for Sale</span>' + '</div>' : '') + (el.rating && el.rating > 0 ? '<div class="rating">' + el.rating + '</div>' : '') + '</div>'
			});

			_tooltip.hide();

			_tooltip.inject(_marker);

			_tooltip.addEvents({
				'click': function click() {
					window.location = el.url;
				}
			});

			_marker.setStyles(self.options.dot_styles);

			var top = 100 - (el.sold_ppsqft - opts.min) * 100 / (opts.max - opts.min) + '%';

			_marker.setStyles({
				top: top
			});

			if (el.image) {
				Asset.image(el.image, {
					onLoad: function onLoad() {
						var _img = new Element('img', {
							src: el.image,
							style: 'max-width: 100%'
						});

						_marker.adopt(_img);
						_marker.setStyle('background', 'none');
					}
				});
			}

			new BlimpExt(_marker, {
				draggable: true,
				show_veil: true,
				rpc_url: el.url_popup,
				onFetch: function onFetch(a, b) {
					_veil.show();
				},
				onPostRpc: function onPostRpc() {
					new BldBlimp(this);
					_veil.hide();
				}
			});
		});
	}
});

Page.Hom.PricingHistoryGraph = new Class({
	Implements: [Options, Events],

	initialize: function initialize(_element) {
		if (!_element) return;

		this._element = _element;

		this.build();
	},

	build: function build() {
		var self = this;

		this.url = this._element.getAttribute('data-rpc');

		new Multiselect(this._element.getElement('.w_multiselect'), {
			text_input: false,
			close_button: false,
			equality: true,
			add_tiles: false
		});

		this._form = this._element.getElement('form');
		this._graph_cont = this._element.getElement('.highchart');
		this._graph = this._element.getElement('.graph');

		this._element.getElements('.w_styled_select select, .w_multiselect').addEvents({
			'change': function change() {
				self.refresh_data();
			}
		});

		this.refresh_data();
	},

	refresh_data: function refresh_data() {
		var self = this;
		var query_string = this._form.toQueryString().trim();

		this._graph_cont.addClass('_loading');

		new Request.JSON({
			url: this.url + query_string,
			method: 'get',

			onSuccess: function onSuccess(data) {
				self.create_chart(data);
				self._graph_cont.removeClass('_loading');
			}
		}).send();
	},

	create_chart: function create_chart(data) {
		var options;
		var quarterly = false;

		Object.some(data, function (el, i) {
			i = i.split(' ');

			quarterly = !!i[1];
			return true;
		}.bind(this));

		options = quarterly ? this.create_quarterly_options(data) : this.create_annual_options(data);

		options = Object.merge(options, {
			chart: {
				renderTo: this._graph,
				backgroundColor: '#f6f6f6',
				zoomType: 'xy',
				paddingTop: 20
			},

			title: null,

			credits: {
				enabled: false
			},

			plotOptions: {
				line: {
					connectNulls: true
				}
			},

			yAxis: [{ // Secondary yAxis
				title: {
					text: 'PRICE / SQ.FT',
					style: {
						color: '#c03e62'
					}
				},
				min: 0,
				labels: {
					formatter: function formatter() {
						return this.value == 0 ? '' : '$' + Core.add_commas(this.value);
					},
					style: {
						color: '#c03e62'
					}
				},
				opposite: true
			}, { // Primary yAxis
				title: {
					text: 'SALES',
					style: {
						color: '#25b2e3'
					}
				},
				min: 0,
				labels: {
					formatter: function formatter() {
						return this.value == 0 ? '' : Core.add_commas(this.value);
					},
					style: {
						color: '#25b2e3'
					}
				}
			}],

			tooltip: {
				shared: true,
				formatter: function formatter() {
					var point1 = this.points[0].point;
					var point2 = this.points[1] ? this.points[1].point : null;
					var index1, index2;

					if (point1.dataGroup) {
						index1 = point1.dataGroup.start;
					} else {
						index1 = point1.index;
					}

					if (point2 && point2.dataGroup) {
						index2 = point2.dataGroup.start;
					} else if (point2) {
						index2 = point2.index;
					}

					var type = document.getElement('._pricing_history select#types').getElement(':selected').get('text');

					var tooltip = '<b>' + point1.series.options.data[index1][2] + ' Sales Data</b><br/>' + 'Total ' + type + ' Sales: ' + Core.add_commas(point1.series.options.data[index1][1]) + '<br/>' + (this.points[1] ? 'Avg. Price / ft<sup>2</sup>: $' + Core.add_commas(point2.series.options.data[index2][1]) + '<br/>' : '') + 'Total ' + type + ' Sales Volume: $' + Core.add_commas(point1.series.options.data[index1][3]);

					return tooltip;
				},
				useHTML: true
			},

			legend: {
				enabled: false
			}
		});

		new Highcharts.Chart(options);
	},

	create_annual_options: function create_annual_options(data) {
		var keys = [];
		var sales = [];
		var prices = [];

		Object.each(data, function (el, i) {
			keys.push(i);
			sales.push([null, el.sales, i, el.price_sum]);
			prices.push([null, el.ppsqft]);
		});

		return {
			xAxis: [{
				categories: keys
			}],

			series: [{
				name: 'Sales',
				color: '#25b2e3',
				type: 'column',
				yAxis: 1,

				data: sales
			}, {
				name: 'Closing Price',
				color: '#c03e62',
				type: 'line',

				data: prices,

				tooltip: {
					valuePrefix: '$'
				},

				marker: {
					radius: 10
				},

				lineWidth: 5
			}]
		};
	},

	create_quarterly_options: function create_quarterly_options(data) {
		var keys = [];
		var sales = [];
		var prices = [];

		var dummy_i = 0;
		var year;

		Object.each(data, function (el, i) {
			i = i.split(' ');
			year = i[0];

			keys.push(dummy_i == 1 ? year : '');
			sales.push([null, el.sales, year + ' ' + i[1], el.price_sum]);
			prices.push([null, el.ppsqft == 0 ? null : el.ppsqft]);

			if (++dummy_i == 4) {
				keys.push('');
				sales.push(null);
				prices.push(null);
				dummy_i = 0;
			}
		});

		if (keys[keys.length - 1] == '' && sales[sales.length - 2] == null) {
			keys[keys.length - 1] = year;
		}

		return {
			xAxis: [{
				categories: keys
			}],

			series: [{
				name: 'Sales',
				color: '#25b2e3',
				type: 'column',
				yAxis: 1,

				data: sales
			}, {
				name: 'Closing Price',
				color: '#c03e62',
				type: 'line',

				data: prices,

				tooltip: {
					valuePrefix: '$'
				},

				marker: {
					radius: 7
				},

				lineWidth: 4
			}]
		};
	}
});

Page.Hom.MarketSnapshotGraph = new Class({
	initialize: function initialize() {
		this._cont = document.getElement('._snapshot');

		if (!this._cont) return;

		var url = this._cont.getAttribute('data-rpc-stats');
		var zone_url = this._cont.getAttribute('data-rpc-zone');

		var veil = this._cont.getElement('.veil');
		veil.setStyle('display', 'block');

		if (!url || url == '') return;

		var self = this;

		this.selected_bedrooms = [];

		var zone_opts = {};

		new Request.JSON({
			url: url,
			onSuccess: function onSuccess(data) {
				var pie_data = [];

				data.each(function (el, i) {
					pie_data.push({
						name: el.name,
						y: el.sales,
						rpc_url: zone_url + '&region=' + el.id,
						avg: el.avg_price,
						sales: el.sales
					});
				});

				var pie = self.create_pie(pie_data, zone_opts);

				zone_opts.url = pie.series[0].data[0].rpc_url;
				zone_opts.sales = pie.series[0].data[0].sales;
				zone_opts.avg = pie.series[0].data[0].avg;
				zone_opts.name = pie.series[0].data[0].name;

				// self.add_market_snapshot_zone(zone_opts, pie.series[0].data[0].config);

				(function () {
					pie.series[0].points[0].select();
					veil.setStyle('display', 'none');
				}).delay(1000);
			}
		}).get();
	},

	add_market_snapshot_zone: function add_market_snapshot_zone(opts, slice) {
		var self = this;

		this._cont.getElement('.top .region').set('html', opts.name);

		if (slice.data) {
			self.create_chart(opts, slice);
		} else {
			this._cont.getElement('.highchart').addClass('_loading');

			new Request.JSON({
				url: opts.url,
				method: 'get',

				onSuccess: function onSuccess(data) {
					slice.data = self.create_marker_snapshot_zone_data(data.list, slice);
					slice.unsorted_data = data;

					self.create_chart(opts, slice);
					self._cont.getElement('.highchart').removeClass('_loading');
				}
			}).send();
		}
	},

	create_pie: function create_pie(pie_data, zone_opts) {
		var self = this;
		var options = {
			chart: {
				renderTo: document.getElement('._snapshot .piechart'),
				plotBackgroundColor: null,
				plotBorderWidth: null,
				plotShadow: false,
				backgroundColor: '#f6f6f6'
			},
			title: null,
			credits: {
				enabled: false
			},
			tooltip: {
				pointFormat: '<b>Sales (past 60 days): </b>{point.y}'
			},
			plotOptions: {
				pie: {
					allowPointSelect: true,
					cursor: 'pointer',
					dataLabels: {
						enabled: false
					},
					showInLegend: true,
					point: {
						events: {
							legendItemClick: function legendItemClick(e) {
								e.preventDefault();
								this.select();
							}
						}
					}
				},

				series: {
					cursor: 'pointer',

					states: {
						select: {
							enabled: false
						}
					},

					point: {
						events: {
							select: function select(e) {
								this.init_color = this.color;

								this.legendSymbol.attr({ fill: '#c03e62' });
								this.graphic.attr({ fill: '#c03e62' });

								zone_opts.url = (e.target.config || e.target.options)['rpc_url'];
								zone_opts.sales = (e.target.config || e.target.options)['sales'];
								zone_opts.avg = (e.target.config || e.target.options)['avg'];
								zone_opts.name = (e.target.config || e.target.options)['name'];

								self.add_market_snapshot_zone(zone_opts, e.target.config || e.target.options);
							},

							unselect: function unselect() {
								this.legendSymbol.attr({ fill: this.init_color });
								this.graphic.attr({ fill: this.init_color });
							}
						}
					}
				}
			},
			series: [{
				type: 'pie',
				data: pie_data
			}]
		};

		Highcharts.setOptions({
			colors: ['#07d4eb', '#07b4c7', '#0694a4', '#057683', '#03565f', '#023b41', '#64E572', '#FF9655', '#FFF263', '#6AF9C4']
		});

		return new Highcharts.Chart(options);
	},

	create_chart: function create_chart(opts, slice) {
		var self = this;
		var options = {
			chart: {
				renderTo: this._cont.getElement('.highchart .graph'),
				type: 'scatter',
				plotBackgroundColor: '#f6f6f6',
				backgroundColor: '#f6f6f6',
				animation: false,
				events: {
					click: function click() {}
				}
			},

			xAxis: {
				labels: {
					enabled: true,
					style: {
						color: '#ccc'
					},
					formatter: function formatter() {
						return Core.add_commas(this.value) + ' sq.ft';
					}
				},

				title: {
					text: null
				},

				tickLength: 0
			},

			yAxis: {
				gridLineColor: '#aaa',
				gridLineDashStyle: 'dash',
				showFirstLabel: false,
				type: 'logarithmic',
				plotLines: [{
					value: 0,
					width: 2,
					color: 'silver'
				}],

				title: {
					text: 'PRICE / SQ. FT',
					style: {
						color: '#ccc'
					},
					margin: 10
				},

				labels: {
					enabled: true,
					style: {
						color: '#ccc'
					},
					formatter: function formatter() {
						return '$' + Core.add_commas(this.value);
					}
				}
			},

			series: slice.data,

			plotOptions: {
				column: {
					stacking: 'normal'
				},

				scatter: {
					marker: {
						radius: 7
					},

					events: {
						click: function click(e) {
							var point = e.point;
							var index;

							if (point.dataGroup) {
								index = point.dataGroup.start;
							} else {
								index = point.index;
							}

							var url = point.series.options.data[index][3];

							if (url) {
								window.location = url;
							}
						}
					}
				},

				series: {
					cursor: 'pointer'
				}
			},

			tooltip: {
				useHTML: true,
				formatter: function formatter() {
					var index;
					if (this.point.dataGroup) {
						index = this.point.dataGroup.start;
					} else {
						index = this.point.index;
					}

					var content = this.point.series.options.data[index][2];

					return content;
				}
			},

			credits: {
				enabled: false
			},

			title: {
				text: null
			},

			legend: {
				enabled: false
			}
		};

		var current_chart = new Highcharts.Chart(options);

		var sales = 0;
		var price = 0;
		var ppsqft = 0;

		var _series_toggles = this._cont.getElements('.highchart .bottom li');

		_series_toggles.removeEvents();

		var first_click = true;

		_series_toggles.each(function (_el, i) {
			if (slice.active_bedrooms.contains(_el.getAttribute('data-id').toInt())) {
				_el.addClass('_active');
				_el.removeEvents();

				_el.addEvents({
					'click': function click() {
						if (first_click) {
							first_click = false;

							_series_toggles.each(function (_e) {
								if (_e !== _el) {
									_e.fireEvent('click');
								}
							});
							self.selected_bedrooms.push(_el.getAttribute('data-id'));
						} else {
							var series = current_chart.series[i];

							if (series.visible) {
								var number_of_visible_series = 0;

								current_chart.series.each(function (el) {
									el.visible ? number_of_visible_series++ : null;
								});

								if (number_of_visible_series < 2) {
									return;
								}

								series.hide();
								_el.removeClass('_selected');
								self.selected_bedrooms.erase(_el.getAttribute('data-id'));
							} else {
								series.show();
								_el.addClass('_selected');
								self.selected_bedrooms.push(_el.getAttribute('data-id'));
							}

							sales = 0;
							price = 0;
							ppsqft = 0;

							current_chart.series.each(function (el) {
								if (el.visible) {
									el.data.each(function (e) {
										if (e.y > 0 && e.x > 0) {
											sales++;
											price += e.y * e.x;
											ppsqft += e.y;
										}
									});
								}
							});

							if (sales > 0) {
								self.set_stats(sales, Math.round(price / sales), Math.round(ppsqft / sales));
							} else {
								self.set_stats(0, 0, 0);
							}
						}
					}
				});

				if (self.selected_bedrooms.length == 0 || self.selected_bedrooms.contains(_el.getAttribute('data-id'))) {
					if (current_chart.series[i]) {
						current_chart.series[i].show();
					}

					_el.addClass('_selected');
				} else {
					if (current_chart.series[i]) {
						current_chart.series[i].hide();
					}

					_el.removeClass('_selected');
					first_click = false;
				}
			} else {
				_el.removeClass('_active');
				_el.removeClass('_selected');

				_el.removeEvents();
			}
		});

		current_chart.series.each(function (el) {
			if (el.visible) {
				el.data.each(function (e) {
					if (e.y > 0 && e.x > 0) {
						sales++;
						price += e.y * e.x;
						ppsqft += e.y;
					}
				});
			}
		});

		if (sales > 0) {
			this.set_stats(sales, Math.round(price / sales), Math.round(ppsqft / sales));
		} else {
			this.set_stats(0, 0, 0);
		}
	},

	create_marker_snapshot_zone_data: function create_marker_snapshot_zone_data(data, slice) {
		var keys = [];
		var data_by_bedrooms = {};
		var graph_colors = ['#b19f00', '#018f9b', '#b4224a', '#484a67', '#ff5a00'];

		slice.active_bedrooms = [];

		data.each(function (el) {
			el.bedroom_id = el.bedroom_id.toInt();
			var bedroom_id = el.bedroom_id > 13 ? 14 : el.bedroom_id;

			if (!data_by_bedrooms[bedroom_id]) {
				data_by_bedrooms[bedroom_id] = {
					data: [],
					color: graph_colors[bedroom_id - 10],
					marker: { symbol: 'circle' }
				};

				slice.active_bedrooms.push(bedroom_id);
				keys.push(bedroom_id);
			}

			if (el.sqft && el.sqft > 0 && el.ppsqft && el.ppsqft > 0) {
				data_by_bedrooms[bedroom_id].data.push([el.sqft, el.ppsqft, el.tooltip, el.url_sold]);
			}
		});

		var series = [];

		keys.sort();
		keys.each(function (e) {
			series.push(data_by_bedrooms[e]);
		});

		return series;
	},

	set_stats: function set_stats(sales, avg, ppsqft) {
		this._cont.getElement('span.sales span').set('html', Core.add_commas(sales));
		this._cont.getElement('span.price span').set('html', Core.add_commas(avg));
		this._cont.getElement('span.priceft span').set('html', Core.add_commas(ppsqft));
	}
});

Page.Hom.FlexWidth = new Class({
	Implements: [Events, Options],

	options: {
		full_width: true //if true - all children have width of their grandparent
	},

	initialize: function initialize(_element, options) {
		this._element = _element || document.getElement('[flexible]');

		if (!this._element) return;

		this.build();
	},

	build: function build() {
		this._children = this._element.getChildren();

		this._children.each(function (_el) {
			_el.setStyles({
				'float': 'left'
			});
		});

		this.resize();

		window.addEvents({
			'resize': this.resize.bind(this),

			'orientationchange': function orientationchange() {
				window.fireEvent('resize');
			}
		});
	},

	resize: function resize() {
		var self = this;
		var width = 0;
		var parent_width = self._element.getParent().getSize().x - 6; // minus border

		this._children.each(function (_el) {
			if (self.options.full_width) {
				_el.setStyle('width', parent_width);
				width += parent_width;
			} else {
				width += _el.getSize().x;
			}
		});

		this._element.setStyles({
			'width': width
		});
	}
});
//# sourceMappingURL=hom.js.map
